export default "__VITE_ASSET__c8tiM_NL__"